/* SieraChart hero surface: data-sc-surface on the hero section turns it on. Sources: hero-surface/ in the project. */
(function () {
var mq = window.matchMedia;
if (!mq || !mq('(hover: hover) and (pointer: fine)').matches || mq('(prefers-reduced-motion: reduce)').matches) return;
var GREEN = '153,255,153';
var RX = 760, RY = 430;
var TEXT_GAIN = 0.2;
var MASK = 4;
var IDLE = 4000;
var FAST = 14, SLOW = 30;
var AZ = 0.62, EL = 0.5, CELL = 30, SCALE = 900, LEVELS = 5;
var ca = Math.cos(AZ), sa = Math.sin(AZ), se = Math.sin(EL), ce = Math.cos(EL);
var SHEET = ['', 'rgb(15,22,17)', 'rgb(19,34,24)', 'rgb(24,46,30)', 'rgb(32,62,40)'];
var INK = [0.3, 0.45, 0.62, 0.82, 1].map(function (a) { return 'rgba(' + GREEN + ',' + a + ')'; });
function smile(U, V) {
var m = (V + 1) * 0.5;
return 260 * U * U * (1.25 - 0.75 * m) - 80 * U * (1 - 0.5 * m) - 50 * m;
}
function surface(hero) {
var canvas = null, ctx = null, W = 0, H = 0, DPR = 1, maxDpr = 1.25, quiet = null;
var raf = 0, last = 0, t = 0, lastMove = 0, gap = FAST;
var mx = 0, my = 0, tx = 0, ty = 0;
var over = false, energy = 0, push = 0, seen = false;
var frames = 0, spent = 0, settle = 0, off = false, tourMs = 0, tourStart = 0;
var N = 0, F = 0, cx = 0, cy = 0, bu, bv, bx, by, bk, sy, lv, vis;
function setup() {
canvas = document.createElement('canvas');
canvas.setAttribute('aria-hidden', 'true');
canvas.style.cssText = 'position:absolute;left:0;top:0;width:100%;height:100%;z-index:-1;pointer-events:none;display:block;max-width:none';
if (getComputedStyle(hero).position === 'static') hero.style.position = 'relative';
hero.style.isolation = 'isolate';
hero.appendChild(canvas);
ctx = canvas.getContext('2d');
if (!ctx) { off = true; canvas.remove(); canvas = null; }
}
function size() {
var w = canvas.clientWidth, h = canvas.clientHeight;
DPR = Math.min(window.devicePixelRatio || 1, maxDpr);
if (w !== W || h !== H || canvas.width !== Math.round(w * DPR)) {
W = w; H = h;
canvas.width = Math.round(w * DPR);
canvas.height = Math.round(h * DPR);
N = 0;
quiet = null;
}
}
function onPlainBox(el) {
for (; el && el !== hero; el = el.parentElement) {
var c = getComputedStyle(el).backgroundColor.match(/[\d.]+/g);
if (c && (c.length < 4 || +c[3] > 0.9)) return true;
}
return false;
}
function quietMask() {
var PAD = 36, OFF = 9999, b = hero.getBoundingClientRect(), fx = W / b.width, fy = H / b.height;
var m = document.createElement('canvas');
m.width = Math.ceil(W / MASK); m.height = Math.ceil(H / MASK);
var c = m.getContext('2d'), range = document.createRange(), any = false;
var walk = document.createTreeWalker(hero, NodeFilter.SHOW_TEXT), node;
c.beginPath();
while ((node = walk.nextNode())) {
if (!/\S/.test(node.nodeValue) || onPlainBox(node.parentElement)) continue;
range.selectNodeContents(node);
var r = range.getClientRects();
for (var i = 0; i < r.length; i++) {
if (!r[i].width || !r[i].height) continue;
c.rect(((r[i].left - b.left) * fx - PAD) / MASK - OFF, ((r[i].top - b.top) * fy - PAD) / MASK,
(r[i].width * fx + 2 * PAD) / MASK, (r[i].height * fy + 2 * PAD) / MASK);
any = true;
}
}
if (!any) return false;
c.shadowColor = '#000';
c.shadowBlur = 12;
c.shadowOffsetX = OFF;
c.fill();
return m;
}
function buildGrid() {
var half = Math.max(W, H * 2) * 0.9;
F = half * 3.2;
cx = W * 0.62; cy = H * 0.6;
N = 2 * Math.ceil(half / CELL) + 1;
var n = N * N;
bu = new Float32Array(n); bv = new Float32Array(n); bx = new Float32Array(n); by = new Float32Array(n);
bk = new Float32Array(n); sy = new Float32Array(n); lv = new Uint8Array(n); vis = new Uint8Array(n);
for (var j = 0, k = 0; j < N; j++) {
for (var i = 0; i < N; i++, k++) {
var u = (i - (N - 1) / 2) * CELL, v = (j - (N - 1) / 2) * CELL;
var X = u * ca - v * sa, Y = u * sa + v * ca, s = F / (F + Y);
bu[k] = u; bv[k] = v;
bx[k] = cx + X * s;
by[k] = cy - Y * se * s;
bk[k] = ce * s;
}
}
}
function drawSurface() {
if (!N) buildGrid();
var cu = 0, cv = 0, z0 = 0, s0 = 1;
for (var it = 0; it < 2; it++) {
var A = my + z0 * ce * s0 - cy;
var Y = -A * F / (se * F + A);
s0 = F / (F + Y);
var X = (mx - cx) / s0;
cu = X * ca + Y * sa;
cv = -X * sa + Y * ca;
z0 = smile(cu / SCALE, cv / SCALE);
}
var spike = 110 + 90 * push;
var ex = 1 / (RX + CELL), ey = 1 / (RY + 240), n = N * N;
for (var k = 0; k < n; k++) {
var px = bx[k], py = by[k], qx = (px - mx) * ex, qy = (py - my) * ey;
if (qx * qx + qy * qy > 1) { vis[k] = 0; continue; }
vis[k] = 1;
var u = bu[k], v = bv[k], U = u / SCALE, V = v / SCALE;
var du = u - cu, dv = v - cv, r2 = du * du + dv * dv, r = Math.sqrt(r2);
var z = smile(U, V)
+ 36 * Math.sin(V * 3.6 - t * 0.85 + U * 1.1)
+ 10 * Math.sin(U * 7 + V * 2.5 + t * 0.55)
+ spike * Math.exp(-r2 / 72200)
+ 52 * Math.sin(r * 0.016 - t * 2.8) * Math.exp(-r / 700);
sy[k] = py - z * bk[k];
var l = (z + 60) / 280 * LEVELS;
lv[k] = l < 0 ? 0 : l >= LEVELS ? LEVELS - 1 : l;
}
ctx.lineWidth = 1 / DPR;
for (var j = N - 1; j > 0; j--) {
var far = j * N, near = (j - 1) * N, a = -1, b = -1, i;
for (i = 0; i < N; i++) {
if (vis[far + i] && vis[near + i]) { if (a < 0) a = i; b = i; }
}
if (a < 0 || a === b) continue;
var majorRow = (j - 1) % 5 === 0, q, any;
ctx.beginPath();
for (i = a; i <= b; i++) ctx.lineTo(bx[far + i], sy[far + i]);
for (i = b; i >= a; i--) ctx.lineTo(bx[near + i], sy[near + i]);
ctx.closePath();
ctx.fillStyle = SHEET[1];
ctx.fill();
for (q = 2; q < LEVELS; q++) {
any = false;
ctx.beginPath();
for (i = a; i < b; i++) {
if (lv[near + i] !== q) continue;
ctx.moveTo(bx[far + i], sy[far + i]);
ctx.lineTo(bx[far + i + 1], sy[far + i + 1]);
ctx.lineTo(bx[near + i + 1], sy[near + i + 1]);
ctx.lineTo(bx[near + i], sy[near + i]);
any = true;
}
if (any) { ctx.fillStyle = SHEET[q]; ctx.fill(); }
}
for (q = 0; q < LEVELS; q++) {
any = false;
ctx.beginPath();
for (i = a; i <= b; i++) {
var kn = near + i, kf = far + i;
if (Math.min(LEVELS - 1, lv[kn] + (i % 5 === 0 ? 1 : 0)) === q) {
ctx.moveTo(bx[kn], sy[kn]); ctx.lineTo(bx[kf], sy[kf]); any = true;
}
if (i < b && Math.min(LEVELS - 1, lv[kn] + (majorRow ? 1 : 0)) === q) {
ctx.moveTo(bx[kn], sy[kn]); ctx.lineTo(bx[kn + 1], sy[kn + 1]); any = true;
}
}
if (any) { ctx.strokeStyle = INK[q]; ctx.stroke(); }
}
}
}
function draw() {
ctx.setTransform(DPR, 0, 0, DPR, 0, 0);
ctx.clearRect(0, 0, W, H);
drawSurface();
ctx.globalCompositeOperation = 'destination-in';
ctx.save();
ctx.translate(mx, my);
ctx.scale(RX, RY);
var g = ctx.createRadialGradient(0, 0, 0, 0, 0, 1);
g.addColorStop(0, 'rgba(0,0,0,' + energy + ')');
g.addColorStop(0.6, 'rgba(0,0,0,' + (energy * 0.85) + ')');
g.addColorStop(1, 'rgba(0,0,0,0)');
ctx.fillStyle = g;
ctx.fillRect(-2, -2, 4, 4);
ctx.restore();
if (quiet === null) quiet = quietMask();
if (quiet) {
ctx.globalCompositeOperation = 'destination-out';
ctx.globalAlpha = 1 - TEXT_GAIN;
ctx.drawImage(quiet, 0, 0, quiet.width * MASK, quiet.height * MASK);
ctx.globalAlpha = 1;
}
ctx.globalCompositeOperation = 'source-over';
}
function frame(now) {
raf = 0;
if (!canvas) return;
var ms = now - last;
if (ms < gap) { raf = requestAnimationFrame(frame); return; }
var dt = Math.min(ms / 16.67, 3) || 1;
last = now;
if (ms < 250) {
if (settle) settle--;
else {
spent += ms;
if (++frames === 45 || spent > 1500) {
var avg = spent / frames;
if (avg > (gap === FAST ? 24 : 44)) {
if (gap === FAST) gap = SLOW;
else if (DPR > 1 && avg < 100) { maxDpr = 1; settle = 20; }
else off = true;
}
frames = 0; spent = 0;
}
}
}
t += 0.016 * dt;
size();
if (tourMs) {
var p = Math.max(now - tourStart, 0) / tourMs;
if (p >= 1) { tourMs = 0; over = false; }
else {
tx = W * (0.42 + 0.53 * p);
ty = H * (0.14 + 0.06 * Math.sin(p * 6.283));
if (!seen) { mx = tx; my = ty; seen = true; }
over = true; lastMove = now; push = 0.35;
}
}
mx += (tx - mx) * (1 - Math.pow(0.9, dt));
my += (ty - my) * (1 - Math.pow(0.9, dt));
var active = over && !off && now - lastMove < IDLE;
energy += ((active ? 1 : 0) - energy) * (1 - Math.pow(active ? 0.93 : off ? 0.7 : 0.965, dt));
push *= Math.pow(0.975, dt);
if (energy < 0.004 && !active) {
energy = 0; seen = false;
canvas.width = canvas.height = 0;
W = H = N = 0;
quiet = bu = bv = bx = by = bk = sy = lv = vis = null;
frames = 0; spent = 0;
return;
}
draw();
raf = requestAnimationFrame(frame);
}
function wake() {
if (!raf && canvas) {
last = performance.now();
raf = requestAnimationFrame(frame);
}
}
function leave() { over = false; wake(); }
window.addEventListener('mousemove', function (e) {
if (off) return;
var b = hero.getBoundingClientRect();
if (!b.width || !b.height) return;
if (e.clientX < b.left || e.clientX > b.right || e.clientY < b.top || e.clientY > b.bottom) {
if (over && !tourMs) leave();
return;
}
if (!canvas) setup();
if (!canvas) return;
var nx = (e.clientX - b.left) * (canvas.clientWidth / b.width);
var ny = (e.clientY - b.top) * (canvas.clientHeight / b.height);
if (!seen) { mx = nx; my = ny; seen = true; }
push = Math.min(1, push + Math.min(Math.hypot(nx - tx, ny - ty), 60) / 260);
tx = nx; ty = ny;
tourMs = 0;
over = true;
lastMove = performance.now();
wake();
}, { capture: true, passive: true });
document.documentElement.addEventListener('mouseleave', leave);
if (hero.getAttribute('data-sc-surface') === 'tour') {
setTimeout(function () {
if (off) return;
if (!canvas) setup();
if (!canvas) return;
tourMs = 6000;
tourStart = performance.now();
seen = false;
wake();
}, 900);
}
}
var heroes = document.querySelectorAll('[data-sc-surface]');
for (var i = 0; i < heroes.length; i++) surface(heroes[i]);
})();
